import React from "react";
import { Link } from "react-router";
import MailingList from "./MailingList";

let Footer = React.createClass({
    render() {
        let year = new Date().getFullYear();

        return (
            <footer className="eo-footer container">
                <nav className="eo-footer-nav grid-10">
                    <div className="footer-nav-item-wrap">
                        <Link className="eo-link-nav eo-nav-item" to="our-story">Our Story</Link>
                    </div>
                    <div className="footer-nav-item-wrap">
                        <Link className="eo-link-nav eo-nav-item" to="jobs">Jobs</Link>
                    </div>
                    <div className="footer-nav-item-wrap">
                        <a className="eo-link-nav eo-nav-item" href="https://blog.eero.com" target="_blank">Blog</a>
                    </div>
                    <div className="footer-nav-item-wrap">
                        <Link className="eo-link-footer eo-nav-item" to="press">Press</Link>
                    </div>
                    <div className="footer-nav-item-wrap">
                        <Link className="eo-link-footer eo-nav-item" to="tos">Legal</Link>
                    </div>
                    <div className="footer-nav-item-wrap">
                        <a className="eo-link-footer eo-nav-item" href="https://pro.eero.com" target="_blank">Pro</a>
                    </div>
                </nav>
                <div className="eo-footer-content grid-10 grid-parent">
                    <MailingList className="grid-5 grid-s-10" successMessage="Thanks! We promise to email responsibly." replace={true} />
                    <section className="social grid-5 grid-s-10 float-right">
                        <a href="https://twitter.com/geteero" className="social-icon icon eo-icon-twitter" target="_blank"/>
                        <a href="https://www.facebook.com/eero" className="social-icon icon eo-icon-facebook" target="_blank"/>
                        <a href="https://www.instagram.com/geteero" className="social-icon icon eo-icon-instagram" target="_blank"/>
                        <a href="https://www.youtube.com/channel/UCFQzmr2fpp1A-GmuDE-9Dlg" className="social-icon icon eo-icon-youtube" target="_blank"/>
                    </section>
                    <p className="copyright">&copy; {year} eero inc.</p>

                    <p className="copyright">San Francisco, CA</p>
                </div>
            </footer>
        );
    }
});

export default Footer;



/** WEBPACK FOOTER **
 ** ./app/views/components/Footer.js
 **/